import React, { useEffect } from 'react';
import { Loader } from 'pixi.js'
import { AnimatedSprite, Container, withFilters, Sprite } from '@inlet/react-pixi'
import { ease } from 'pixi-ease'
import { GlowFilter } from 'pixi-filters';

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

let challengeJetTextures = [];

const ChallengeJet = ({ _xPos, _yPos, speed, _yMax, _xMax, route }) => {
    const [filter, setFilter] = React.useState(0);
    const loader = Loader.shared;
    const planeSprite = React.useRef();
    const textSprite = React.useRef();

    let smokeTextTexture = loader.resources["./assets/images/components/island/spritesheets/skyAssets/challengeSmokeText.json"].textures[`text (11).png`];

    for (let i = 1; i <= 4; i++) {
        challengeJetTextures.push(loader.resources["./assets/images/components/island/spritesheets/skyAssets/skyAsset.json"].textures[`jetplane_0${i}.png`]);
    }

    useEffect(() => {
        if (planeSprite.current !== null && planeSprite.current !== undefined) {
            const example1 = ease.add(planeSprite.current, { scaleX: 2, scaleY: 2, position: { x: _xMax - 200, y: _yMax + 20 } }, { repeat: true, duration: 48000 })
            example1.once('complete', () => {
                planeSprite.current.x = _xPos;
                planeSprite.current.y = _yPos;
            })
            example1.on('each', () => {
                if (planeSprite.current.x >= 1250 && planeSprite.current.x <= 1350)
                    first();
                else if (planeSprite.current.x >= 300 && planeSprite.current.x <= 400)
                    second();
            })
        }
        return () => { ease.removeAll(); }
    }, []);

    const first = () => {
        textSprite.current.visible = true;
        textSprite.current.x = _xPos - 400;
        textSprite.current.y = _yPos + 150;
        const example1 = ease.add(textSprite.current, { alpha: 1 }, { reverse: true, duration: 3000 })
    }

    const second = () => {
        textSprite.current.visible = true;
        textSprite.current.x = _xMax + 400;
        textSprite.current.y = _yMax - 240;
        const example2 = ease.add(textSprite.current, { alpha: 1 }, { reverse: true, duration: 3000 })
    }

    return (
        <Container>
            <Filters scale={1} glow={{ distance: 100, outerStrength: 2, innerStrength: 2 / 4, quality: 0, color: '0xf5f5f5' }}>
                <Sprite ref={textSprite}
                    scale={{ x: 0.7, y: 0.7 }}
                    texture={smokeTextTexture}
                    alpha={0}
                    interactive={true} buttonMode={true}
                    pointerdown={() => {
                        route("Hello World")
                    }}
                />
            </Filters>
            <Container x={_xPos} y={_yPos} ref={planeSprite}>
                <Filters scale={1} glow={{ distance: 100, outerStrength: filter, innerStrength: filter / 4, quality: 0, color: '0xf5f5f5' }}>
                    <AnimatedSprite
                        animationSpeed={0.15}
                        isPlaying={true} scale={{ x: 0.3, y: 0.3 }}
                        textures={challengeJetTextures}
                        interactive={true} buttonMode={true}
                        pointerdown={() => {
                            route("Hello World")
                        }}
                        pointerover={() => setFilter(2)}
                        pointerout={() => setFilter(0)}
                    />
                </Filters>
            </Container>
        </Container>
    );
};

export { ChallengeJet as default }